/**
 * * 处理断网的情况
 * @Mixin
 */
import NetworkMixin from '@/mixins/network'
import utils from '@/utils/utils'
import { mapState } from 'vuex'
export default {
  mixins: [NetworkMixin],
  computed: {
    ...mapState({
      docId: state => state.routeInfo.docId,
      userId: state => state.routeInfo.userId,
    }),
    onLine() {
      return this.netWorkData.onLine
    }
  },
  created () {
    this.messageNumber = 0
  },
  data() {
    return {
      watchOnLine: true,
      message: null,
      messageInterval: null,
      messageNumber: 0
    }
  },
  watch: {
    // * 网络监听
    onLine (newValue) {
      if (!newValue) {
        this.notOnlineHandle()
        return;
      } else {
        if (this.$store.getters.fileObject.docSource === 10) {
          utils.toEditPage()
        }
      }
      if (this.messageInterval) {
        clearInterval(this.messageInterval)
      }
      if (this.message) {
        this.message.close()
      }
    }
  },
  methods: {
    // * 网络中断处理
    notOnlineHandle() {
      this.$store.state.wpsUrl ? this.openMessage() : this.jumpErrorPage()
    },
    // * 未获取 wps 数据之前-----暂时不用了，等稳定后再删除
    noData() {
      this.$alert('网络异常，请检查网络设置，请重试或退出编辑！', '提示', {
        showClose: false,
        confirmButtonText: '重试',
        callback: () => {
          if(this.onLine) {
            utils.toEditPage()
          } else {
            this.noData()
          }
        }
      })
    },
    // * 有wps数据且在当前ref界面------暂时不用，等待稳定后删除
    hasWpsData () {
      if (this.$refs.editViewRef) {
        // 外部的 mixins
        try {
          this.webOnlineEditClearWpsUrl()
        } catch (err) {
          console.log(err);
        }
      }
      this.$router.replace(`/webOnlineEdit/page/notline/${this.docId}/${this.userId}`)
    },
    // * 打开断网的消息提示
    openMessage () {
      this.message = this.$message({
        dangerouslyUseHTMLString: true,
        showConfirmButton: false,
        closeOnClickModal: false,
        message:
          '网络异常，文档最新内容会在网络恢复后同步，正在重连<span class="not-line-message-point">...</span>',
        duration: 0,
        type: 'error',
        customClass: 'newsErrorMessage'
      })
      this.messageInterval = setInterval(() => {
        this.messageNumber += 1
        const pointDom = document.querySelector('.not-line-message-point')
        if (pointDom) {
          const pointNum = this.messageNumber % 3
          switch (pointNum) {
            case 0:
              pointDom.innerText = '.'
              break
            case 1:
              pointDom.innerText = '..'
              break
            case 2:
              pointDom.innerText = '...'
              break
          }
        }
      }, 1000)
    },
    // 跳转错误页面
    jumpErrorPage () {
      this.$router.replace(`/webOnlineEdit/server/error/${this.docId}/${this.userId}`)
    }
  },
  destroyed () {
    if (this.messageInterval) {
      clearInterval(this.messageInterval)
    }
    if (this.message) {
      this.message.close()
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/network/wpsHandle.js